// src/components/pages/Movimento/list/helpers/getRowActionsContent.js
import React from 'react';
import { Box, IconButton, Tooltip } from '@mui/material';
import { Delete, Edit, ReceiptLong, PictureAsPdf } from '@mui/icons-material';

import { OPERACAO_SIGLAS } from '../../shared/constants';
import { filtrarDocumentos } from '../../shared/helpers/documentos';
import {
    podeEditar,
    podeCancelarMovimento,
    podeEditarMovimento,
    podeImprimirMovimento,
} from '../../../../../hooks/usePermisionMRT';

export function getRowActionsContent({
    row,
    operacao,
    origem,
    operacaoParametrosDocumentos,
    getDocumentoIcon,
    handleImprimir,
    printEtiquetasGrande,
    handleOpenDialog,
    navigate,
    pathname,
    params,
}) {
    const documentosFiltrados = filtrarDocumentos({
        documentos: operacaoParametrosDocumentos,
        origem,
        sigla: operacao?.sigla?.toLowerCase(),
    });
    const isFechado = row?.original?.Situacao?.descricao === 'Fechado';
    const isBalancoFechado = operacao?.balanco && isFechado;

    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                flexWrap: 'nowrap',
                gap: 0.25,
                width: 'max-content',
            }}
        >
            <Tooltip
                arrow
                placement="bottom"
                title={`${row.original.transformado === true ? 'Transformado não pode ser Editado' : 'Editar'}`}
            >
                <span>
                    <IconButton
                        size="small"
                        onClick={() => {
                            params.set('uuid', row.id);
                            params.set('btnText', 'Atualizar');
                            params.set('operacaoId', row.original.operacaoId);
                            navigate(pathname, params);
                        }}
                        disabled={!podeEditarMovimento(row)}
                    >
                        <Edit fontSize="small" />
                    </IconButton>
                </span>
            </Tooltip>

            <Tooltip
                arrow
                placement="top"
                title={`${row.original.transformado === true ? 'Transformado não pode ser Deletado' : 'Deletar'}`}
            >
                <span>
                    <IconButton
                        size="small"
                        color="error"
                        onClick={() => {
                            handleOpenDialog(row, 'cancelar');
                        }}
                        disabled={!podeCancelarMovimento(row) || isBalancoFechado}
                    >
                        <Delete fontSize="small" />
                    </IconButton>
                </span>
            </Tooltip>

            {operacao?.sigla?.toLowerCase() !== OPERACAO_SIGLAS.REST.toLowerCase() && (
                <Tooltip arrow placement="top-start" title="Anexar documento ao movimento, recibo, NF, Pedido, Garantia, etc">
                    <span>
                        <IconButton
                            size="small"
                            color="error"
                            onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                handleOpenDialog(row, 'comprovantes');
                            }}
                            disabled={!podeEditar()}
                        >
                            <PictureAsPdf fontSize="small" />
                        </IconButton>
                    </span>
                </Tooltip>
            )}
            {documentosFiltrados.map((documento, index) => (
                <Tooltip
                    key={documento.uuid || index}
                    arrow
                    placement={index % 2 === 0 ? 'top-start' : 'bottom-start'}
                    title={`Imprimir ${documento.Documento.descricao}`}
                >
                    <span>
                        <IconButton
                            size="small"
                            onClick={() => handleImprimir(documento, row.original)}
                            disabled={!podeImprimirMovimento(row)}
                        >
                            {getDocumentoIcon(documento?.Documento?.tipo)}
                        </IconButton>
                    </span>
                </Tooltip>
            ))}

            {operacao?.sigla?.toLowerCase() === OPERACAO_SIGLAS.CFR.toLowerCase() && origem !== OPERACAO_SIGLAS.REQ && (
                <Tooltip arrow placement="right" title="Imprimir etiqueta grande">
                    <span>
                        <IconButton
                            size="small"
                            onClick={() => printEtiquetasGrande({ body: row.original })}
                            disabled={!podeImprimirMovimento(row)}
                        >
                            <ReceiptLong fontSize="small" />
                        </IconButton>
                    </span>
                </Tooltip>
            )}
        </Box>
    );
}
